/**
 * main.tsx — React + wagmi + react-query bootstrap.
 *
 * We import the wagmi/Reown config as a side effect (it calls
 * createAppKit at module load) and wrap the tree in WagmiProvider +
 * QueryClientProvider so wallet hooks work anywhere in the app.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { wagmiConfig } from "./lib/wagmi";
import { App } from "./App";
import "./styles/index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // wagmi tunes its own per-hook staleTime; we're just setting sane
      // fallbacks for anything else we fetch via react-query later.
      staleTime: 5_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root element missing from index.html");
}

createRoot(rootEl).render(
  <StrictMode>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </WagmiProvider>
  </StrictMode>,
);
